<div class="flex items-center gap-2 rounded-full bg-white py-1.5 pr-3 pl-1">
  <icon-ui
    name="search"
    class="text-accent-900 size-5 shrink-0" />
  <input
    data-test="search-field"
    type="text"
    class="text-primary-900 preset-body-3 md:preset-body-2 w-full bg-transparent outline-none"
    [placeholder]="placeholder()"
    [attr.aria-label]="placeholder()"
    name="search"
    [formControl]="searchControl" />
  <button
    data-test="clear-button"
    type="button"
    aria-label="Limpiar búsqueda"
    [clicks]="'clear-search'"
    (click)="searchControl.setValue('')"
    class="text-danger-900 cursor-pointer"
    [class.invisible]="!searchControl.value?.trim()">
    <icon-ui
      name="close"
      class="size-4" />
  </button>
</div>
